import { ConfigAttribute, AttributeOption, AttributeOptionId } from 'app/types/project-config';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ObjID } from 'app/model/id-manager';

@Component({
  selector: 'app-attribute-option-selector',
  templateUrl: './attribute-option-selector.component.html',
  styleUrls: ['./attribute-option-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributeOptionSelectorComponent implements OnInit {

  private _ready = false;
  constructor(private cdr: ChangeDetectorRef) { }

  private _attribute?: ConfigAttribute;
  @Input()
  public set attribute(attr: ConfigAttribute | undefined) {
    this._attribute = attr;
    window.requestAnimationFrame(() => {

      if (attr && attr.options) {
        if ((attr.options.length > 0) && (attr.options[0].label.toLowerCase().indexOf('select ') === 0)) {
          if (!attr.default) {
            this.needSelect = false;
            this.selectedOptionId = attr.options[0].id as AttributeOptionId;
          }
        }
      }
      this.Refresh();

    });
    this.Refresh();
  }
  public get attribute(): ConfigAttribute | undefined {
    return this._attribute;
  }

  public get options(): Array<AttributeOption> {
    if (!(this._attribute && this._attribute.options)) return [];
    return this._attribute.options;
  }
  public needSelect = true;

  @Input()
  public selectedOptionId: ObjID = 0;
  @Output()
  public selectedOptionIdChange = new EventEmitter<ObjID>()
  ngOnInit(): void {
    this._ready = true;
  }

  Refresh() {
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }
  NotifyListeners() {
    this.selectedOptionIdChange.emit(this.selectedOptionId);
  }
}
